module.exports = __webpack_public_path__ + "static/media/rightdisable.fc025602.svg";